import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { useAppDispatch } from '../../../../redux/hooks';
import { fetchUserFees } from '../../../../redux/modules/userFee/userFee.actions';
import { userSelector } from '../../../../redux/modules/user/user.selectors';
import { UserFeesTabList } from './UserFeesTabList';
import { productTypeSelector } from '../../../../redux/modules/productType/product-type.selectors';
import { fetchProductTypes } from '../../../../redux/modules/productType/product-type.actions';
import { FeeDetailsTab } from './FeeDetailsTab';

import { SectionCard } from '../../../../components/Section';

interface FeesTabProps {
  userId: number;
}

export function FeesTab({ userId }: FeesTabProps) {
  const dispatch = useAppDispatch();
  const { error } = useSelector(userSelector);
  const { productTypes, fetchStatus } = useSelector(productTypeSelector);
  const isLoading = fetchStatus === fetchStatuses.pending;

  useEffect(() => {
    dispatch(fetchProductTypes({ limit: 100, offset: 0 }));
  }, []);

  useEffect(() => {
    if (userId) {
      dispatch(
        fetchUserFees({
          limit: 100,
          offset: 0,
          sortField: 'id',
          sortOrder: 'desc',
          filter: JSON.stringify({
            items: [
              { columnField: 'userId', operatorValue: '=', value: userId },
              // { columnField: 'status.name', operatorValue: 'is', value: SubscribedPortfolioStatus.ACCEPTED },
            ],
          }),
          // relations: ['subscribedPortfolioAssociatedIndexFund'],
        }),
      );
    }
  }, []);

  return (
    <>
      {error && <Alert severity="error">{error.message}</Alert>}
      <SectionCard title="Fee details" sx={{ height: '450px' }}>
        <Box sx={{ position: 'relative', width: '100%' }}>{!isLoading && <FeeDetailsTab />}</Box>
      </SectionCard>
      <SectionCard title="User fees" sx={{ mt: '16px' }}>
        <Box sx={{ position: 'relative', width: '100%' }}>
          {!isLoading && <UserFeesTabList userId={userId} productTypes={productTypes} />}
        </Box>
      </SectionCard>
    </>
  );
}
